'use client'

import * as Sentry from '@sentry/nextjs'
import { useTranslations } from 'next-intl'
import { Suspense } from 'react'

import ZSuspenseError from '@/_components/universal/z-suspense-error'
import ZSuspenseLoading from '@/_components/universal/z-suspense-loading'
import { useGetReferenceGroup } from '@/app/[locale]/references/services/references.query'

import ZReferencesGroup from './z-references-group'

interface IProps {
	slug: string
	className?: string
}

const ZReferencesContent = ({ slug, className }: IProps) => {
	const t = useTranslations('components.zReferences')

	try {
		const { data: referenceGroup, isLoading, error } = useGetReferenceGroup(slug)

		if (isLoading) {
			return <ZSuspenseLoading />
		}

		if (error || !referenceGroup) {
			return <ZSuspenseError title={t('errorTitle')} />
		}

		return <ZReferencesGroup referenceGroup={referenceGroup} className={className} />
	} catch (error) {
		Sentry.captureException(error)

		return <ZSuspenseError title={t('errorTitle')} />
	}
}

export default function ZReferences({ slug, className }: IProps) {
	return (
		<Suspense fallback={<ZSuspenseLoading />}>
			<ZReferencesContent slug={slug} className={className} />
		</Suspense>
	)
}
